<template>
  <div class="footer">
    <div class="footer__top">
      <container>
        <div class="position-relative">
          <div class="footer__left">
            <img src="@/assets/img/shapes/shape-7.svg" alt="" class="shape-7">
            <v-link
              to="/iletisim"
              class="green round footer__button"
              icon="icon-plus"
              icon-position="right"
              title="Yurdumu Ekle"
            />
          </div>
          <div class="footer-ctr">
            <div class="footer-ctr__item">
              <span class="footer-ctr__icon">
                <svg-icon type="icon-mail" />
              </span>
              <div class="footer-ctr__txt" v-if="settings">
                <a href="mailto:destek@yurtlarburada.com">{{ settings.setting.email }}</a>
              </div>
            </div>

            <div class="footer-ctr__item">
              <span class="footer-ctr__icon">
                <svg-icon type="icon-headphone" />
              </span>
              <div class="footer-ctr__txt" v-if="settings">
                <a href="tel:+905412129878">{{ settings.setting.mobile_phone }}</a>
              </div>
            </div>
          </div>
        </div>
      </container>
    </div>
    <container>
      <div class="footer__wrp">
        <div class="footer-inf">
          <img src="@/assets/img/logo-footer.svg" alt="" class="footer-inf__logo">
          <div class="footer-inf__txt" v-if="settings">
            {{ settings.setting.address }}
          </div>
          <SocialGroup />
        </div>
        <div class="footer-list">
          <div class="footer__col">
            <div class="footer-links">
              <div class="footer-links__title"><span class="color-blue">Hızlı Arama</span> Metodları</div>
              <router-link class="footer-links__item" v-for="link in searchLinks" :key="link.id" :to="link.to">
                <span class="icon-font">
                  <svg-icon type="icon-search" />
                </span>
                <span class="btn-txt">
                  {{ link.title }}
                </span>
              </router-link>
            </div>
          </div>

          <div class="footer__col">
            <div class="footer-links">
              <div class="footer-links__title"><span class="color-blue">Yurtlar için</span> İlanlar</div>
              <router-link class="footer-links__item" v-for="link in advertLinks" :key="link.id" :to="link.to">
                <span class="btn-txt">
                  {{ link.title }}
                </span>
              </router-link>
            </div>
          </div>

          <div class="footer__col">
            <div class="footer-links">
              <router-link class="footer-links__item" v-for="link in mainLinks" :key="link.id" :to="link.to">
                <span class="btn-txt">
                  {{ link.title }}
                </span>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="footer-sec">
        <div class="clearfix"></div>
        <ul class="contractLinks">
          <li>
            <a href="/gizlilik-politikasi">
              <strong class="text d-block font-500">Gizlilik Politikası</strong>
            </a>
          </li>
          <li>
            <a href="/iptal-ve-iade-kosullari">
              <strong class="text d-block font-500">İptal ve İade Koşulları</strong>
            </a>
          </li>
          <li>
            <a href="/mesafeli-satis-sozlesmesi">
              <strong class="text d-block font-500">Mesafeli Satış Sözleşmesi</strong>
            </a>
          </li>
          <li>
            <a href="/kullanici-sozlesmesi">
              <strong class="text d-block font-500">Kullanıcı Sözleşmesi</strong>
            </a>
          </li>
        </ul>
        <div class="clearfix"></div>
        <strong class="text d-block font-700 color-gray" v-if="settings">{{ settings.setting.copyright }}</strong>

        <div class="footer-sec__cards">
          <img src="@/assets/img/shapes/shape-8.svg" alt="" class="shape-8">
          <img src="@/assets/img/payments.png" alt="" class="footer-sec__img">
        </div>
        <div class="clearfix"></div>
      </div>
    </container>
  </div>
</template>

<script>
import SocialGroup from '@/components/SocialGroup'
import { mapGetters } from 'vuex'
export default {
  name: 'Footer',
  components: {
    SocialGroup
  },
  data () {
    return {
      searchLinks: [
        {
          id: 0,
          title: 'Şehre Göre Ara',
          to: { name: 'CityList' }
        },
        {
          id: 1,
          title: 'Üniversiteye Göre Ara',
          to: { name: 'UniSearch' }
        },
        {
          id: 2,
          title: 'Yurt Adına Göre Ara',
          to: { name: 'DormSearch' }
        },
        {
          id: 3,
          title: 'Yurt Fiyatları',
          to: { name: 'RequestPrice' }
        }
      ],
      advertLinks: [
        {
          id: 0,
          title: 'Alım Talepleri',
          to: '/ilanlar/alim-talepleri'
        },
        {
          id: 1,
          title: 'Eleman Arayanlar',
          to: '/ilanlar/eleman-arayanlar'
        },
        {
          id: 2,
          title: '2. Yurt Araç Gereçleri',
          to: '/ilanlar/arac-gerecler'
        },
        {
          id: 3,
          title: 'Araç İlanları',
          to: '/ilanlar/arac-ilanlari'
        }
      ],
      mainLinks: [
        {
          id: 0,
          title: 'Hakkımızda',
          to: '/hakkimizda'
        },
        {
          id: 1,
          title: 'Basında Biz',
          to: '/basinda-biz'
        },
        {
          id: 2,
          title: 'S.S.S',
          to: '/sik-sorulan-sorular'
        },
        {
          id: 3,
          title: 'Blog',
          to: '/blog'
        },
        {
          id: 4,
          title: 'İletişim',
          to: '/iletisim'
        }
      ]

    }
  },
  computed: {
    ...mapGetters(['settings'])
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/footer";
</style>
